/**
 * @file コンポーネント：フル動画ページ機器広告ポップアップ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPopup = styled.div``;

export const StyledPopupContents = styled.div`
    position: relative;
`;

export const StyledPopupContainer = styled.div``;

export const StyledPopupImage = styled.img`
    max-width: 100%;
    max-height: 100%;
`;
